import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', function () {

	// Находим контейнер с фильтрами
	document.querySelectorAll('.aqua-map').forEach(function (slide) {
		const slider = new Swiper(slide.querySelector('.aqua-map__swiper'), {
			slidesPerView: 1,          // Один видимый слайд
			spaceBetween: 10,
			// Ключевые параметры по заданию:
			allowTouchMove: false,     // ЗАПРЕТ прокрутки пальцем / мышкой
			autoHeight: true,          // АВТОВЫСОТА — подстраивается под высоту активного слайда

			// Чтобы автовысота работала корректно при изменении контента:
			observer: true,            // Наблюдает за изменениями в DOM слайдера
			observeParents: true,      // Наблюдает за изменениями родительских элементов
		});
		const btnsContainer = slide.querySelector('.aqua-map__btns');
		const btns = slide.querySelectorAll('.aqua-map__btn');
		console.log('btns', btns)


		// Функция обновления позиции и ширины подложки
		function updateSliderPosition(activeButton) {
			const buttonRect = activeButton.getBoundingClientRect();
			const containerRect = btnsContainer.getBoundingClientRect();

			// Вычисляем позицию относительно контейнера
			const leftPosition = buttonRect.left - containerRect.left;
			const buttonWidth = buttonRect.width;



			// Обновляем CSS переменные (если нужно)
			btnsContainer.style.setProperty('--width', `${buttonWidth}px`);
			btnsContainer.style.setProperty('--left', `${leftPosition}px`);
		}

		// Функция активации фильтра
		function activateFilter(button) {
			// Удаляем активный класс у всех кнопок
			btns.forEach(btn => {
				btn.classList.remove('active');
			});
			slider.slideTo(parseInt(button.dataset.slide))
			// Добавляем активный класс текущей кнопке
			button.classList.add('active');

			// Обновляем позицию подложки
			updateSliderPosition(button);

		}

		btns.forEach(button => {
			button.addEventListener('click', function () {
				activateFilter(this);
			});
		});

		// Находим активную кнопку (по умолчанию "Все")
		let activeButton = slide.querySelector('.aqua-map__btn.active');
		if (!activeButton) {
			activeButton = slide.querySelector('.aqua-map__btn');
			if (activeButton) {
				activeButton.classList.add('active');
			}
		}

		// Устанавливаем начальную позицию подложки
		if (activeButton) {
			updateSliderPosition(activeButton);
		}


		// Обновляем позицию подложки при изменении размера окна
		let resizeTimeout;
		window.addEventListener('resize', function () {
			clearTimeout(resizeTimeout);
			resizeTimeout = setTimeout(() => {
				const currentActive = slide.querySelector('.qua-map__btn.active');
				if (currentActive) {
					updateSliderPosition(currentActive);
				}
			}, 100);
		});


		slide.querySelectorAll('.aqua-map__slide').forEach(function (s) {
			const filters = s.querySelectorAll('.aqua-map__filter')
			const items = s.querySelectorAll('.aqua-map__map-item')

			filters.forEach(filter => {
				filter.addEventListener('click', function () {
					filters.forEach(f => {
						f.classList.remove('_active')
					})
					filter.classList.add('_active')
					items.forEach(item => {
						if (item.dataset.filter == filter.dataset.filter || filter.dataset.filter == 'all') {
							item.classList.remove('_hidden')
						} else {
							item.classList.add('_hidden')
						}
					})
				})
			})

		})
	})
});